import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const baseUrl = 'https://fulidaohang.com';

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '福利导航',
    url: baseUrl,
    description: '福利导航为您汇聚全网优质福利资源，涵盖电商优惠、会员权益、生活补贴、职场福利等多类目，帮助用户快速找到最划算的福利入口，省时省钱不踩坑。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${baseUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '福利导航',
    url: baseUrl,
    description: '一站式福利资源聚合平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@fulidaohang.com',
      contactType: 'customer service',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '福利导航是免费使用的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，福利导航完全免费使用。我们致力于为所有用户提供优质的福利资源聚合服务，不收取任何费用。',
        },
      },
      {
        '@type': 'Question',
        name: '福利信息多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的团队每天都会监控各大平台的福利动态，确保信息的及时性和准确性。重点关注电商大促、会员日活动、节假日福利等时间节点。',
        },
      },
      {
        '@type': 'Question',
        name: '如何确保福利信息的真实性？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们建立了一套严格的福利信息审核机制：所有发布的福利信息都经过人工核实，优先收录官方渠道发布的福利。',
        },
      },
    ],
  };

  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [websiteSchema, organizationSchema, faqSchema],
  };

  return (
    <>
      <SEO
        title="福利导航 - 一站式福利资源聚合平台"
        description="福利导航为您汇聚全网优质福利资源，涵盖电商优惠、会员权益、生活补贴、职场福利等多类目，帮助用户快速找到最划算的福利入口，省时省钱不踩坑，是您发现好福利的首选导航平台。"
        keywords="福利导航,福利资源导航,优惠福利汇总,会员权益导航,生活福利大全,电商优惠导航,职场福利查询,免费福利领取"
        canonicalUrl="/"
        schema={combinedSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}